module.exports = __webpack_public_path__ + "static/first-image-bc88a5a8fb262550a302592a8e10c844.svg";